import { PropsWithChildren } from 'react';
import {
  Typography,
  TypographyProps,
} from '../../../../../design-system/components/typography/typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { Gap, Row } from '../../../../../design-system/components/grid/grid';
import { Button } from '../../../../../design-system/components/button/button';
import { CampaignSetupProps } from '.';
import { trackEvent } from '@services/tracking';

const El = (p: PropsWithChildren) => (
  <>
    <Row gap="m">
      <FontAwesomeIcon icon={faCheck} />
      <Typography variant="body" size="large">
        {p.children}
      </Typography>
    </Row>
    <Gap height="l" />
  </>
);

const FakeLink = (p: PropsWithChildren<TypographyProps>) => (
  <Typography
    color="P-80"
    style={{ textDecoration: 'underline', cursor: 'pointer' }}
    as="span"
    {...p}
  >
    {p.children}
  </Typography>
);

export type WelcomeScreenProps = Pick<
  CampaignSetupProps,
  'changeTab' | 'setStarted'
>;

export const WelcomeScreen = (p: WelcomeScreenProps) => {
  const handleStartCampaignClick = () => {
    p.setStarted(true);

    trackEvent({
      type: 'Campaign Set Up Started',
      payload: {},
    });
  };

  return (
    <>
      <Typography variant="body" size="medium" color="N-80">
        Already have campaign defined? Check metrics on{' '}
        <FakeLink onClick={() => p.changeTab('performance')}>
          Performance
        </FakeLink>
      </Typography>
      <Gap height="l" />
      <Typography variant="headline" size="medium">
        Set up your campaign
      </Typography>
      <Gap height="l" />
      <El>
        To track performance of paid ads, <br />
        first go to{' '}
        <FakeLink onClick={() => p.changeTab('integrations')}>
          Integrations
        </FakeLink>
      </El>
      <El>
        Set up unique campaign links to track performance of your paid and non
        paid campaigns
      </El>
      <El>
        Use campaign links on social media, embed in emails or on your website
      </El>
      <Button
        color="neutral"
        style={{ minWidth: '120px' }}
        onClick={handleStartCampaignClick}
      >
        Start
      </Button>
    </>
  );
};
